define('models/CustomerLikeCollection',['underscore', 'jquery', 'ObjectCollection', 'LocalStorage', 'router', 'app', 'models/CustomerLikeModel'], function (_, $, ObjectCollection, LocalStorage, router, app, CustomerLikeModel) {
    //
    // Collection CartProduct
    //
    var CustomerLikeCollectionPrototype = {

        model: CustomerLikeModel,

        attachCustomer: function (customer) {
            this.customer = customer;
        },
    };

    var CustomerLikeCollection  = ObjectCollection.extend(CustomerLikeCollectionPrototype);

    return CustomerLikeCollection;
});

